module.exports = __webpack_public_path__ + "img/bv.63455590.svg";